import React, { useEffect, useState } from 'react';
import { Box, styled } from '@mui/material';
import CoachPageLayout from '../../components/CoachPageLayout/CoachPageLayout';
import ActiveClients from '../../components/ClientTable/ActiveClients/ActiveClients';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { fetchClientsRequest } from '../../redux/client/clientSlice';
import { PaginationModelChangeProps } from '../../components/ClientTable/ClientTable';
import OnboardingSuccessModal from '../../components/Onboarding/OnboardingSuccessModal';
import SubscriptionBanner from '../../components/SubscriptionBanner/SubscriptionBanner';

export interface ClientsProps {
  pageSize: number;
  currentPage: number;
  skip: number;
  handleOnPaginationModelChange: (_event: PaginationModelChangeProps) => void;
}

export const StyledBox = styled(Box)(() => ({
  padding: 0,
  boxShadow: ' 0px 4px 40px 0px #FFDDC840',
  backgroundColor: '#FFF',
  border: '1px solid #7CAEBE80',
  borderTopLeftRadius: '0px !important',
  borderTopRightRadius: '0px !important',
  borderRadius: '5px',
  bgcolor: '#fff',
}));

export interface ClientsTableProps {
  coachId?: string;
}

// clients page for coach
const Clients = ({ coachId }: ClientsTableProps) => {
  const dispatch = useAppDispatch();
  const coach = useAppSelector((state) => state.coach.coach);

  // Active clients pagination
  const [pageSizeActive, setPageSizeActive] = useState<number>(10);
  const [currentPageActive, setCurrentPageActive] = useState<number>(0);
  const skipActive = currentPageActive * pageSizeActive;

  const handlePaginatiChangeActive = (event: PaginationModelChangeProps) => {
    setPageSizeActive(event.pageSize);
    setCurrentPageActive(event.page);
  };

  useEffect(() => {
    if (coach) {
      const payload = {
        coachId: coachId || coach?.id,
        nameText: '',
        skip: skipActive,
        take: pageSizeActive,
        isArchived: false,
      };
      dispatch(fetchClientsRequest(payload));
    }
  }, []);

  return (
    <>
      <CoachPageLayout>
        <ActiveClients
          pageSize={pageSizeActive}
          currentPage={currentPageActive}
          skip={skipActive}
          handleOnPaginationModelChange={handlePaginatiChangeActive}
        />
        <SubscriptionBanner />
      </CoachPageLayout>
      <OnboardingSuccessModal />
    </>
  );
};

export default Clients;
